import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import { Badge, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React, { useCallback } from "react";
import { AccountContext } from "../context/account";
import { AddressBookItem } from "../core/global";

interface AddressBookSelectProps {
  onChange: (newVal: string) => void
  value: string
  id: string
  label?: string
  showEdit?: boolean
  useAddressBook?: AddressBookItem[] | null
}

export const AddressBookSelect = ({
  onChange,
  value,
  id,
  label = '',
  showEdit = false,
  useAddressBook = null
}: AddressBookSelectProps) => {

  const {
    addressBook,
    userActivePaymentMethod,
  } = React.useContext(AccountContext);


  const SelectElement = useCallback( () => {
    const showAddressBook = useAddressBook || addressBook
    return (
      <>
        {showAddressBook && 
          <Select
            labelId="address-select"
            id="address-select"
            value={value}
            label={label}
            onChange={(event: SelectChangeEvent) => {
              onChange(event.target.value as string);
            }}
          >
            {
              showAddressBook.map((org: AddressBookItem) => {
                const {id, name, default_address, is_external_address} = org
                return (
                  <MenuItem
                    key={`${id}-${name}`} 
                    value={id}
                  >
                    <>
                      {name}
                      {default_address ? <Badge badgeContent="default" color="primary" style={{transform: 'translate(27px,-6px)'}} /> : null}
                      {is_external_address ? <Badge badgeContent="external" color="secondary" style={{transform: 'translate(27px,-6px)'}} /> : null}
                    </>
                </MenuItem>
                )
              })
            }
            <MenuItem value={'new'}><AddIcon sx={{mr: "8px"}} /> Create new billing address</MenuItem>
            {showEdit && <MenuItem value={'edit'}><EditIcon sx={{mr: "8px"}} /> Edit your address book</MenuItem>}
          </Select>
        }
      </>
    )
  }, [onChange, value, id, label, showEdit])

  if (!addressBook || addressBook.length === 0) {
    return null
  }

  if (label) {
    return (
      <FormControl
        fullWidth
      >
        <InputLabel id={id}>{label}</InputLabel>
        <SelectElement />
      </FormControl>
    )
  }
  return (
    <SelectElement />
  )
}


